import {
    call,
    take,
    select
} from 'redux-saga/effects';
import {
    SORT_CATEGORY
} from '../actions/sortActions';
import {
    beginRequestSaga
} from './categoryInitialSagas';

export function *sortSaga() {
    let payload = {};

    // eslint-disable-next-line no-cond-assign
    while ({ payload } = yield take(SORT_CATEGORY)) {
        const requestedPage = 1;
        let state = yield select();

        yield call(
            beginRequestSaga,
            requestedPage,
            payload.requestType,
            state.category.categorySlug,
            state.category.searchTerm,
            payload.queryString
        );
    }
}

export default [
    sortSaga
];
